import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const ServiceCard = ({ title, icon: Icon, description, category, details }) => {
  const [open, setOpen] = useState(false);
  const hasDetails = Boolean(details);

  return (
    <div className="group relative overflow-hidden rounded-2xl border border-slate-100 bg-white p-8 shadow-sm transition-all duration-500 hover:shadow-xl">
      <div className="absolute -right-12 -top-12 h-24 w-24 rounded-bl-full bg-slate-50 opacity-50 transition-transform duration-700 group-hover:scale-150" />
      <div className="relative z-10">
        <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-xl bg-slate-900 text-white transition-colors duration-300 group-hover:bg-emerald-700">
          <Icon size={28} />
        </div>
        <span className="mb-2 block text-[10px] font-bold uppercase tracking-[0.2em] text-emerald-600">
          {category}
        </span>
        <h3 className="mb-3 text-2xl font-semibold text-slate-800">{title}</h3>
        <p className="mb-6 text-sm leading-relaxed text-slate-600">{description}</p>
        {hasDetails && (
          <>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-expanded={open}
              className="flex w-full items-center justify-between gap-3 text-left text-xs font-bold uppercase tracking-widest text-slate-900 transition-colors hover:text-emerald-700"
            >
              Detalles
              <ChevronDown size={18} className={`shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
            </button>
            {open && (
              <div className="mt-5 space-y-3 border-t border-slate-100 pt-5 text-sm leading-relaxed text-slate-600">
                {details}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ServiceCard;
